function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 5.528V3.753C4 1.633 5.84 0 8 0s4 1.634 4 3.753v1.775a6 6 0 11-8 0zm1.472-1.775C5.472 2.533 6.555 1.46 8 1.46s2.528 1.072 2.528 2.292v.804A5.977 5.977 0 008 4c-.903 0-1.76.2-2.528.557v-.804zM7 9a1 1 0 112 0v2a1 1 0 11-2 0V9z",
  fill: "currentColor"
})));